module.exports = __webpack_public_path__ + "assets/img/23_131_big.84d910b8.jpg";